/* Core by Chloe Pilates — shared add-to-bag helpers (v9). Used by The Rail and the product grid. */
(function () {
  if (window.cbcAddToBag) return;
  function drawer() { return document.querySelector('cart-drawer'); }

  window.cbcAddToBag = function (variantId, qty) {
    var dr = drawer();
    var body = { items: [{ id: Number(variantId), quantity: qty || 1 }] };
    if (dr && typeof dr.getSectionsToRender === 'function') {
      body.sections = dr.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw (j.description || j.message || 'This could not be added to your bag.');
        return j;
      });
    });
  };

  window.cbcShowBag = function (state) {
    var dr = drawer();
    if (dr && typeof dr.renderContents === 'function' && state && state.sections) {
      dr.classList.remove('is-empty');
      dr.renderContents(state);
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cbc-clean', cartData: state });
        }
      } catch (e) {}
    } else {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  };

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-cx-add]') : null;
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('[data-cx-msg]');
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = btn.getAttribute('data-adding') || 'Adding';
    if (msg) msg.hidden = true;
    window.cbcAddToBag(form.querySelector('[name="id"]').value, 1)
      .then(function (state) { window.cbcShowBag(state); })
      .catch(function (m) { if (msg) { msg.textContent = String(m); msg.hidden = false; } })
      .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; });
  });
})();